import type { PendingQuantityWrite } from "./quantity-write-queue";

export function canRetryQuantityWrite(item: PendingQuantityWrite, identity: {
  terminalCode: string; operatorId: string; sessionId: string;
}) {
  return item.terminalCode === identity.terminalCode && item.operatorId === identity.operatorId &&
    item.sessionId === identity.sessionId && item.status !== "SENDING";
}

export const QUANTITY_ATTEMPT_LEASE_MS = 30_000;
export type QuantityWriteIdentity = { terminalCode: string; operatorId: string; sessionId: string };
export function recoverInterruptedWrite(item: PendingQuantityWrite, now: number): PendingQuantityWrite {
  return item.status === "SENDING" && (item.attemptedAt === null || now - item.attemptedAt >= QUANTITY_ATTEMPT_LEASE_MS)
    ? { ...item, status: "UNCERTAIN", everUncertain: true, error: "Önceki gönderimin sonucu doğrulanamadı; sunucudan kontrol edin." } : item;
}
export function claimQuantityAttempt(item: PendingQuantityWrite, identity: QuantityWriteIdentity, now: number): PendingQuantityWrite | null {
  const current = recoverInterruptedWrite(item, now);
  if (!canRetryQuantityWrite(current, identity) || current.status === "FAILED") return null;
  return { ...current, status: "SENDING", attempts: current.attempts + 1, attemptedAt: now, error: null };
}
export function quantityAttemptFailed(item: PendingQuantityWrite, definitivelyRejected: boolean, message: string): PendingQuantityWrite {
  // A rejection of a later retry says nothing about the first attempt's commit.
  const failed = definitivelyRejected && item.attempts === 1 && !item.everUncertain;
  return { ...item, status: failed ? "FAILED" : "UNCERTAIN", everUncertain: !failed || item.everUncertain, error: message };
}
